import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a481dfac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"margin-top":"-10px"} }
const _hoisted_7 = { style: {"color":"#409eff","text-decoration":"none"} }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100% !important","background-color":"#409eff"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"19% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 要素名称 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"81% !important","color":"#fff","text-align":"center"} }, " 子要素 ")
], -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["title"]
const _hoisted_12 = { style: {"float":"left","width":"81% !important"} }
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  key: 0,
  style: {"position":"relative","border-radius":"2px","width":"14px","height":"14px","border":"1px solid #ccc","top":"-27px","left":"15px","background-color":"#ccc"}
}
const _hoisted_15 = {
  key: 1,
  style: {"text-indent":"1px","position":"relative","border-radius":"2px","width":"14px","height":"14px","border":"1px solid #409eff","top":"-27px","left":"15px","line-height":"14px","background-color":"#409eff","color":"#ffffff","font-size":"10px"}
}
const _hoisted_16 = {
  key: 1,
  style: {"width":"100% !important","padding-bottom":"10px","padding-top":"10px","border-bottom":"1px solid #efefef","text-align":"center","height":"40px","line-height":"40px"}
}
const _hoisted_17 = { style: {"width":"100% !important","background-color":"#409eff"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"19% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 供应商名称 ")
], -1))
const _hoisted_19 = { style: {"float":"left","width":"19% !important","color":"#fff","text-align":"center"} }
const _hoisted_20 = { style: {"border-right":"1px solid #efefef","width":"100%"} }
const _hoisted_21 = { style: {"float":"left","width":"19% !important","color":"#fff","text-align":"center"} }
const _hoisted_22 = { style: {"border-right":"1px solid #efefef","width":"100%"} }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"19% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 交货时间 ")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"19% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 存放地点 ")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"5% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, " 操作 ")
], -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["title"]
const _hoisted_28 = { style: {"float":"left","width":"19% !important","text-align":"center"} }
const _hoisted_29 = { style: {"float":"left","width":"19% !important","text-align":"center"} }
const _hoisted_30 = { style: {"padding-left":"2px"} }
const _hoisted_31 = { style: {"float":"left","width":"19% !important","text-align":"center"} }
const _hoisted_32 = ["title"]
const _hoisted_33 = { style: {"float":"left","width":"5% !important","text-align":"center"} }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 1,
  style: {"width":"100% !important","padding-top":"10px","text-align":"center","height":"40px","line-height":"40px"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 历史记录 ", -1))
const _hoisted_37 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_38 = { style: {"width":"100%"} }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "原值：", -1))
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新值：", -1))
const _hoisted_43 = {
  key: 0,
  style: {"font-weight":"900"}
}
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { style: {"clear":"both"} }
const _hoisted_46 = { style: {"margin-top":"20px","clear":"both","height":"40px","line-height":"40px","text-align":"center","color":"#409eff","font-weight":"900"} }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"30px"} }, null, -1))
const _hoisted_49 = { style: {"clear":"both"} }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 规格图片 ", -1))
const _hoisted_51 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_52 = { style: {"width":"100% !important"} }
const _hoisted_53 = { style: {"width":"100%","height":"100%","text-align":"center","background-color":"#fff"} }
const _hoisted_54 = ["href"]
const _hoisted_55 = ["src"]
const _hoisted_56 = { style: {"width":"100%","text-align":"center","font-weight":"900"} }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_58 = { style: {"clear":"both"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_thumbnail = _resolveComponent("miezz-thumbnail")!
  const _component_Check = _resolveComponent("Check")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Document = _resolveComponent("Document")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_menu_tab, {
      modelValue: _ctx.menuTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", null, [
      _createVNode(_component_miezz_form, {
        ref: "ruleForm",
        modelValue: _ctx.detail,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail) = $event)),
        fix: true
      }, {
        "form-item": _withCtx(({ item }) => [
          (item.Prop == 'ProductName')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                prop: item.Prop,
                label: item.Label
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isString(_ctx.product.Data.NameZh)) + " / " + _toDisplayString(_ctx.isString(_ctx.product.Data.NameEn)), 1)
                ]),
                _: 2
              }, 1032, ["prop", "label"]))
            : _createCommentVNode("", true),
          (item.Prop == 'Name')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                prop: item.Prop,
                label: item.Label
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isString(_ctx.detail.Data.Name)), 1)
                ]),
                _: 2
              }, 1032, ["prop", "label"]))
            : _createCommentVNode("", true),
          (item.Prop == 'Weight')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                prop: item.Prop,
                label: item.Label
              }, {
                default: _withCtx(() => [
                  (_ctx.isString(_ctx.detail.Data.Weight) == '暂无数据')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.isString(_ctx.detail.Data.Weight)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.isString(_ctx.detail.Data.Weight)) + " KGS ", 1))
                ]),
                _: 2
              }, 1032, ["prop", "label"]))
            : _createCommentVNode("", true),
          (item.Prop == 'SpecImages')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 3,
                prop: item.Prop,
                label: item.Label
              }, {
                default: _withCtx(() => [
                  (_ctx.detail.Data.SpecImages!=null && _ctx.detail.Data.SpecImages!=undefined && _ctx.detail.Data.SpecImages.length>0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.Data.SpecImages, (p, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            title: p.Name,
                            key: index,
                            style: {"height":"100px","width":"100px","overflow":"hidden","text-align":"center","margin-top":"-15px","float":"left","margin-right":"15px","cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.onImage(p))
                          }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("img", {
                                style: {"height":"60px"},
                                src: p.Url
                              }, null, 8, _hoisted_5)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("span", _hoisted_7, _toDisplayString(p.Name), 1)
                            ])
                          ], 8, _hoisted_4))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _createVNode(_component_miezz_thumbnail, {
                          modelValue: undefined,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((undefined) = $event)),
                          type: 'image',
                          icon: 'DocumentDelete'
                        })
                      ]))
                ]),
                _: 2
              }, 1032, ["prop", "label"]))
            : _createCommentVNode("", true),
          (item.Prop == 'NumberString')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 4,
                prop: item.Prop,
                label: item.Label
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isString(_ctx.detail.Data.NumberString)), 1)
                ]),
                _: 2
              }, 1032, ["prop", "label"]))
            : _createCommentVNode("", true),
          (item.Prop == 'SpecElements')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 5,
                prop: item.Prop,
                label: item.Label
              }, {
                label: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(item.Label), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_9,
                  (_ctx.IsProductSpecElement!=false && _ctx.productSpecElements!=null && _ctx.productSpecElements.length>0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productSpecElements, (p, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            style: {"width":"100% !important","padding-bottom":"10px","padding-top":"10px"},
                            key: index
                          }, [
                            _createElementVNode("div", {
                              style: {"float":"left","width":"19% !important","text-align":"center","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"},
                              title: p.Name
                            }, _toDisplayString(p.Name), 9, _hoisted_11),
                            _createElementVNode("div", _hoisted_12, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.ProductSpecElementItems, (p1, index1) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  style: {"float":"left","margin-left":"0px","height":"40px","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"},
                                  key: index1
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(p1.IsSelected == true?'div-category-select-detail':'div-category-detail')
                                  }, [
                                    _createElementVNode("div", {
                                      title: p1.Name,
                                      style: {"overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap","width":"100% !important"}
                                    }, _toDisplayString(p1.Name), 9, _hoisted_13)
                                  ], 2),
                                  (p1.IsSelected == false)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Check)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, " 暂无数据 "))
                ]),
                _: 2
              }, 1032, ["prop", "label"]))
            : _createCommentVNode("", true),
          (item.Prop == 'SpecStocks' && _ctx.ProductManagement_ProductManagement_ProductInformation_SpecificationAndModel_InventoryInformation==true)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 6,
                prop: item.Prop,
                label: item.Label
              }, {
                label: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(item.Label), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, " 数量（" + _toDisplayString(_ctx.product.Data.ChargeUnithZh) + "） ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, " 采购价/" + _toDisplayString(_ctx.product.Data.ChargeUnithZh), 1)
                    ]),
                    _hoisted_23,
                    _hoisted_24,
                    _hoisted_25
                  ]),
                  (_ctx.detail.Data.SpecStocks!=null && _ctx.detail.Data.SpecStocks.length>0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.Data.SpecStocks, (p, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            style: {"width":"100% !important","padding-top":"10px"},
                            key: index
                          }, [
                            _createElementVNode("div", {
                              style: {"float":"left","width":"19% !important","text-align":"left","overflow":"hidden","height":"30px"},
                              title: p.Supplier
                            }, _toDisplayString(_ctx.isString(p.Supplier)), 9, _hoisted_27),
                            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.isString(p.Quantity)), 1),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("span", null, _toDisplayString(p.CurrencyName), 1),
                              _createElementVNode("span", _hoisted_30, _toDisplayString(p.Price), 1)
                            ]),
                            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.isString(p.DeliveryTimeString)), 1),
                            _createElementVNode("div", {
                              style: {"float":"left","width":"19% !important","text-align":"left","overflow":"hidden","height":"30px"},
                              title: p.Address
                            }, _toDisplayString(_ctx.isString(p.Address)), 9, _hoisted_32),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("span", {
                                title: "历史记录",
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (_ctx.onHistoryStock(p))
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Document)
                                  ]),
                                  _: 1
                                })
                              ], 8, _hoisted_34)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_35, " 暂无数据 "))
                ]),
                _: 2
              }, 1032, ["prop", "label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_miezz_button_bar, {
        modelValue: _ctx.bottomButtons,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bottomButtons) = $event)),
        onHandleClick: _ctx.handleClick
      }, null, 8, ["modelValue", "onHandleClick"]),
      (_ctx.historyForm != undefined)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 0,
            modelValue: _ctx.historyForm.Visible,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.historyForm.Visible) = $event)),
            "show-close": false,
            style: {"width":"70%"},
            top: "0px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": true
          }, {
            header: _withCtx(({ close }) => [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("div", {
                style: {"width":"100% !important","line-height":"30px","margin-top":"-10px"},
                key: _ctx.historyRandom
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historys, (p, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: {"clear":"both","margin-top":"20px"},
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_38, [
                      (p.OldItem!=null && p.OldItem.length>0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _hoisted_40,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.OldItem, (p1, index1) => {
                              return (_openBlock(), _createElementBlock("span", { key: index1 }, "【" + _toDisplayString(p1.Label) + "/" + _toDisplayString(p1.OldLabel) + "】", 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (p.NewItem!=null && p.NewItem.length>0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _hoisted_42,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.NewItem, (p1, index1) => {
                              return (_openBlock(), _createElementBlock("span", { key: index1 }, [
                                (p1.State==3)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, "【" + _toDisplayString(p1.Label) + "/" + _toDisplayString(p1.NewLabel) + "】", 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_44, "【" + _toDisplayString(p1.Label) + "/" + _toDisplayString(p1.NewLabel) + "】", 1))
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_45, " 操作人：" + _toDisplayString(p.CreatedUser) + "  操作时间：" + _toDisplayString(p.CreatedTime) + "  操作内容：" + _toDisplayString(p.Title), 1)
                    ])
                  ]))
                }), 128))
              ])),
              _createElementVNode("div", _hoisted_46, [
                (_ctx.historyForm.IsEnd!=true)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      style: {"cursor":"pointer"},
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onNextHistory()))
                    }, "显示更多"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_47, "无更多信息"))
              ]),
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_miezz_button_bar, {
                  modelValue: _ctx.historyBottomButtons,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.historyBottomButtons) = $event)),
                  isBackground: true,
                  onHandleClick: _ctx.handleClickHistory
                }, null, 8, ["modelValue", "onHandleClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.imageForm != undefined)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 1,
            modelValue: _ctx.imageForm.Visiable,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.imageForm.Visiable) = $event)),
            "show-close": false,
            style: {"width":"50%"},
            top: "30px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": true
          }, {
            header: _withCtx(({ close }) => [
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_component_el_carousel, {
                  interval: 5000,
                  arrow: "hover"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageForm.Rows, (p, index) => {
                      return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("a", {
                              href: p.Url,
                              target: "_blank"
                            }, [
                              _createElementVNode("img", {
                                style: {"height":"85%"},
                                src: p.Url
                              }, null, 8, _hoisted_55)
                            ], 8, _hoisted_54),
                            _createElementVNode("div", _hoisted_56, _toDisplayString(p.Name), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _createVNode(_component_miezz_button_bar, {
                  modelValue: _ctx.bottomButtonsImage,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bottomButtonsImage) = $event)),
                  isBackground: true,
                  onHandleClick: _ctx.handleClickImage
                }, null, 8, ["modelValue", "onHandleClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}